module.exports = __webpack_public_path__ + "img/ezDealerLogo.25dc05af.svg";